import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { SettingsButton } from "../../../../../components/settingsButton/SettingsButton";
import { ModalService } from "../../../../../components/modal";
import { CategoriesByStatus } from "../webFilters.types";
import { ProtectionEditorDialog } from "./ProtectionEditorDialog";
import { ChangeProtectionCategoriesFn } from "../protectionEditor/protectionEditor.types";

import "./ProtectionEditorDialog.scss";

interface ProtectionEditorDialogContainerProps {
  categories: CategoriesByStatus;
  profileId: string;
  changeStatus: ChangeProtectionCategoriesFn;
  blockedByWebFilter?: string[];
  isActive?: boolean;
}

export const ProtectionEditorDialogContainer = ({
  categories,
  profileId,
  changeStatus,
  blockedByWebFilter,
  isActive = true,
}: ProtectionEditorDialogContainerProps) => {
  const { blocked, allowed } = categories;

  const btnProps = {
    color: "secondary",
    size: "large",
    className: "protection-editor__settings-btn",
    disabled: !isActive,
  };

  const openModal = (
    categories: CategoriesByStatus,
    profileId: string,
    blockedByWebFilter: string[]
  ) =>
    ModalService.show((modal) => ({
      dialog: (
        <ProtectionEditorDialog
          categories={categories}
          profileId={profileId}
          blockedByWebFilter={blockedByWebFilter}
          modal={modal}
        />
      ),
    }));

  return (
    <SettingsButton
      {...btnProps}
      label={<FormattedMessage id={"categories"} />}
      status={
        <Fragment>
          <FormattedMessage id={"blocked"} />
          <span className={"settings-btn__counter"}>
            {" "}
            {blocked.length}/{blocked.length + allowed.length}
          </span>
        </Fragment>
      }
      onClick={() =>
        openModal(categories, profileId, blockedByWebFilter)
          .then(changeStatus)
          .catch(() => null)
      }
    />
  );
};
